export const HINHANH_SET_LIST_DATA = 'HINHANH_SET_LIST_DATA';
export const HINHANH_SET_LIST_META = 'HINHANH_SET_LIST_META';
export const HINHANH_TITLE = 'Hình ảnh';